export default __webpack_public_path__ + "static/media/wwr-img.4ad7a4c2.webp";